import { useMemo } from 'react';
import { Tag } from 'antd';
import {
  FaUserClock,
  FaUserCheck,
  FaTools,
  FaGlobe,
  FaGhost,
} from 'react-icons/fa';

export const useStatusRender = () => {
  return useMemo(() => {
    return (type: string) => {
      const typeConfigs: {
        [key: string]: {
          bgColor: string;
          textColor: string;
          borderColor: string;
          icon: React.ReactNode;
          text: string;
        };
      } = {
        ONE_TIME: {
          bgColor: '#e6f7ff',
          textColor: '#1890ff',
          borderColor: '#91d5ff',
          icon: <FaUserClock />,
          text: 'One-time',
        },
        REGULAR: {
          bgColor: '#f9f0ff',
          textColor: '#722ed1',
          borderColor: '#d3adf7',
          icon: <FaUserCheck />,
          text: 'Regular',
        },
        MAINTENANCE: {
          bgColor: '#fff7e6',
          textColor: '#fa8c16',
          borderColor: '#ffd591',
          icon: <FaTools />,
          text: 'Maintenance',
        },
        NRI: {
          bgColor: '#f6ffed',
          textColor: '#52c41a',
          borderColor: '#b7eb8f',
          icon: <FaGlobe />,
          text: 'NRI',
        },
        GHOST: {
          bgColor: '#fafafa',
          textColor: '#222222',
          borderColor: '#dddddd',
          icon: <FaGhost />,
          text: 'Ghost',
        },
      };

      const config = typeConfigs[type] || {
        bgColor: '#f5f5f5',
        textColor: '#8c8c8c',
        borderColor: '#d9d9d9',
        icon: <FaUserClock />,
        text: type,
      };

      return (
        <Tag
          style={{
            display: 'inline-flex',
            alignItems: 'center',
            gap: '6px',
            fontWeight: 500,
            padding: '4px 8px',
            borderRadius: '6px',
            lineHeight: '1.2',
            backgroundColor: config.bgColor,
            color: config.textColor,
            border: `1px solid ${config.borderColor}`,
          }}
        >
          <span style={{ display: 'flex', alignItems: 'center' }}>
            {config.icon}
          </span>
          <span>{config.text}</span>
        </Tag>
      );
    };
  }, []);
};
